export enum CampaignOMType {
  STATIC = "STATIC",
  DYNAMIC = "DYNAMIC",
}
